import { useEffect, useState } from 'react';
import {
  useCharacterStore,
  useNarrativeStore,
  useWorldStore,
  useMetaStore,
} from '@/engine/state';
import { TamperDetectedError, esTamperError } from '@/engine/persistence';

/**
 * Carga los stores desde storage al montar la app.
 * Si detecta tampering, dispara el cosmic game over.
 * Devuelve un flag `listo` que indica si ya podemos renderizar el juego.
 */
export function useBootstrapStores(): boolean {
  const [listo, setListo] = useState(false);
  const cargarCharacter = useCharacterStore((s) => s.cargarDesdeStorage);
  const cargarNarrative = useNarrativeStore((s) => s.cargarDesdeStorage);
  const cargarWorld = useWorldStore((s) => s.cargarDesdeStorage);
  const dispararCosmico = useMetaStore((s) => s.dispararCosmicGameOver);

  useEffect(() => {
    try {
      cargarCharacter();
      cargarNarrative();
      cargarWorld();
    } catch (err) {
      if (esTamperError(err)) {
        dispararCosmico(
          `El tejido de la realidad se ha fracturado. [${(err as TamperDetectedError).keyAfectada}]`,
        );
      } else {
        // Otros errores no esperados: re-lanzar al error boundary
        throw err;
      }
    } finally {
      setListo(true);
    }
  }, [cargarCharacter, cargarNarrative, cargarWorld, dispararCosmico]);

  return listo;
}
